import React from "react";
import * as XLSX from "xlsx";
import excelIcon from "../../icons/excel-logo.svg";
import Tippy from "@tippyjs/react";


const columns = [
  { header: "WO No.", key: "workOrderNumber" },
  { header: "WOLI No.", key: "workOrderLineItemNumber" },
  { header: "SA No.", key: "serviceAppointmentNumber" },
  { header: "Owner", key: "owner" },
  { header: "Owner Organization", key: "ownerOrganization" },
  {
    header: "Captured Date",
    key: "dateOnImage",
    isDate: true,
  },
  // {
  //   header: "Image Uploaded Date",
  //   key: "imageUploadedDateTime",
  //   isDate: true,
  // },
  { header: "File Extension", key: "imageFileExtension" },

  {
    header: "Upload Date/Time to AMS",
    isDate: true,
    getValue: (item) =>
      item.dbInsertedDateTime || item.imageUploadedDateTime || null,
  },

  { header: "File Name", key: "fileName" },
  { header: "Work Type", key: "workOrderLineItemWorkType" },
  { header: "Site ID", key: "siteId" },
  { header: "Site Name", key: "siteName" },
  { header: "Patch ID", key: "patchId" },
  { header: "Patch Name", key: "patchName" },
];

function DownloadExcelButton({ currentItemsUsers }) {
  function convertJSONToExcel(currentItemsUsers) {
    const sheetData = [
      columns.map((col) => col.header),
      ...(currentItemsUsers ?? []).map((item) =>
        columns.map((col) => {
          // const value = item[col.key];

          const value = col.getValue ? col.getValue(item) : item[col.key];

          if (col.isDate && value) {
            return new Date(value);
          }

          return value ?? "";
        }),
      ),
    ];

    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Metadata");

    // Generate a blob from the workbook
    // const blob = XLSX.write(wb, { bookType: 'xlsx', type: 'blob' });

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Convert the buffer to a blob
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    return blob;
  }

  function downloadExcel() {
    const excelBlob = convertJSONToExcel(currentItemsUsers);
    const url = URL.createObjectURL(excelBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "Metadata.xlsx";
    link.click();
  }

  return (
    <Tippy
      content={
        <>
          {currentItemsUsers?.length
            ? "Download Excel"
            : "No items selected for download"}
        </>
      }
      placement="bottom"
      theme="custom"
    >
      <span>
        <button
          className="btn-download excel-btn-download"
          onClick={downloadExcel}
          disabled={!currentItemsUsers?.length}
          >
          <span>Metadata</span>
          <img
            src={excelIcon}
            alt="Excel"
            className="excel-btn-download__icon"
          />
        </button>
      </span>
    </Tippy>
  );
}

export default DownloadExcelButton;
